import {useMutation} from '@tanstack/react-query';
import {useAxios} from '../../hooks/axios/useAxios';
import {acknowledgementUrl} from "../../constants/api/soft-user/endpoints";

interface QueryParams {
  portfolio_id?: string,
  institution_message_id?: string
}

export const useMutateAcknowledgement = () => {
  const axios = useAxios();

  const handleRequest = (params: QueryParams) => {
    return axios.put(acknowledgementUrl, {...params})
        .then(response => response?.data ?? response);
  };

  return useMutation({
    mutationKey: ['acknowledgement-submit'],
    mutationFn: handleRequest
  })
};
